@if (typeTitle) {
  <span class="pill" [ngClass]="cssClass">{{ typeTitle }}</span>
}
